export const SET_CURRENT_USER_ID = 'SET_CURRENT_USER_ID';
export const SET_CURRENT_COLLABORATOR_ID = 'SET_CURRENT_COLLABORATOR_ID';
export const SET_CURRENT_FILE_ID = 'SET_CURRENT_FILE_ID';
export const SET_CURRENT_FILERR_ID = 'SET_CURRENT_FILERR_ID';
export const SET_CURRENT_GROUP_ID = 'SET_CURRENT_GROUP_ID';
export const SET_CURRENT_COMMENT_ID = 'SET_CURRENT_COMMENT_ID';
export const SET_CURRENT_TIMECODE = 'SET_CURRENT_TIMECODE';
